var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCircleRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 207,
    viewBox: "0 0 71 207",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M94.0899 9.62223L87.1162 198.622C87.1162 198.622 84.533 209.169 73.2536 206.221C47.0338 199.366 -4.2586 157.226 1.15582 96.2886C6.57024 35.3508 55.1007 4.52786 79.416 0.886239C91.6142 -0.940648 94.0899 9.62223 94.0899 9.62223Z",
    fill: "#F1F1F1"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleRight);
export default __webpack_public_path__ + "static/media/circle_right.f3327a007082234247b3c2ff463a766a.svg";
export { ForwardRef as ReactComponent };